import { oAuth, ssoLogin, getRoles } from '@/api/login'
import { configApi } from "@/api/api.js";
import store from '@/vuex/store'

/**
 *
 */
export const change_userInfo = ({ commit }, _userInfo) => {
  commit('CHANGE_USERSCHOOL', _userInfo)
}
/**
 *
 */
export const localLogin = ({ commit }, params) => {
  // 标识宿主平台
  commit('setPlatform', params.type || '');
  let loginFun = null
  if (params.type === 'sso' || params.type === 'zujuan') {
    loginFun = ssoLogin()
  } else if (params.type === 'oauth') {
    loginFun = oAuth(params.token)
  } else {
    return Promise.reject({ code: 601, message: '登录认证不存在' });
  }

  return loginFun.then(async (resp) => {
    if (resp.code != 0 || !resp.body.userId) {
      return Promise.reject(resp);
    }
    const user = resp.body
    if (!user.academicYearType) {
      user.academicYearType = 0
    }
    // 在调用接口之前，先设置学校id和token
    YJ_SCHOOL_STORAGE.setItem('schoolId', user.schoolId);
    YJ_SCHOOL_STORAGE.setItem('token', user.token);

    // 标识初次登录平台
    let loginPlatform = 'region' // 区域平台：region / 学校平台：school
    if (user.schoolType === 1) {
      loginPlatform = 'school'
    }
    store.commit('v2/setLoginPlatform', loginPlatform)
    // 如果参数里有isLittleDoctor，则设置isLittleDoctor为true
    if (params.isLittleDoctor === 'true') {
      if (!user.productPermissionIds) {
        user.productPermissionIds = []
      }
      user.productPermissionIds.push('LittleDoctor')
    }

    await getRoles(user)
    try {
      let response = await configApi.getConfigByTypes(user.schoolId, ['EXAM_OTHER_WATERMARK'])
      if (response.body) {
        if (response.body.length) {
          sessionStorage.setItem("school-report-watermark", parseInt(response.body[0].configValue));
        }
      }
    } catch (error) { }

    return Promise.resolve(user)
  }).catch((error) => {
    return Promise.reject(error)
  })
}
